import React, { ReactNode } from 'react';

interface KpiGridProps {
  children: ReactNode;
}

export function KpiGrid({ children }: KpiGridProps) {
  return <div className="row g-3">{children}</div>;
}
